module.exports = __webpack_public_path__ + "img/newyear_rule_title.19e21365.png";